'use client';

import { NavLink } from './NavLink';
import { getAnchorIds, resolveHref } from './navigation.utils';
import { useScrollSpy } from '@/hooks';
import { usePathname } from 'next/navigation';
import { useSiteSettings } from '@/components/providers';

type RestProps = {
    className?: string;
};

export function NavigationMain({ className }: RestProps) {
    const settings = useSiteSettings();
    const items = settings.navigation?.main ?? [];
    const pathname = usePathname();
    const anchorIds = getAnchorIds(items);
    const activeAnchorId = useScrollSpy({ ids: anchorIds });

    return (
        <nav className={className} aria-label="Main navigation">
            <ul className="flex gap-4 justify-end md:gap-6">
                {items.map((item) => {
                    const href = resolveHref(item);
                    const isAnchor = Boolean(item.anchor);
                    const isActive = isAnchor ? item.anchor === activeAnchorId : pathname === href;

                    return (
                        <li key={item._key}>
                            <NavLink
                                item={item}
                                isActive={isActive}
                                className="text-xs font-semibold uppercase underline underline-offset-4"
                            />
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}
